import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdLibraryAdd, MdOutlineReceiptLong, MdPersonAddAlt } from 'react-icons/md';
import { FaChevronRight, FaChartBar } from 'react-icons/fa';

/**
 * Fixed 4-action row from the Inicio handoff spec: icon tile + label +
 * sub-copy + hover-reveal chevron.
 */
function QuickActionsRow() {
	const navigate = useNavigate();

	const actions = [
		{
			key: 'cargar-pago',
			icon: <MdLibraryAdd />,
			label: 'Cargar pago',
			sub: 'Registrar un cobro',
			onClick: () => navigate('/AdminScreen/quickPayment'),
		},
		{
			key: 'ingresar-gasto',
			icon: <MdOutlineReceiptLong />,
			label: 'Ingresar gasto',
			sub: 'Cargar una factura o gasto',
			onClick: () => navigate('/AdminScreen/newBill'),
		},
		{
			key: 'nueva-cuenta',
			icon: <MdPersonAddAlt />,
			label: 'Nueva cuenta',
			sub: 'Alta de cliente o propietario',
			onClick: () => navigate('/AdminScreen/newAccount'),
		},
		{
			key: 'generar-informe',
			icon: <FaChartBar />,
			label: 'Generar informe',
			sub: 'Ver reportes y balances',
			onClick: () => navigate('/AdminScreen/reports'),
		},
	];

	return (
		<div className='tw:grid tw:grid-cols-4 tw:max-lg:grid-cols-2 tw:gap-3 tw:mb-6'>
			{actions.map((action) => (
				<button
					key={action.key}
					type='button'
					onClick={action.onClick}
					className='tw:group tw:flex tw:items-center tw:gap-3 tw:p-3.5 tw:bg-surface tw:border tw:border-border tw:rounded-panel tw:text-left tw:transition-[border-color,box-shadow,transform] tw:duration-150 tw:hover:border-border-strong tw:hover:shadow-raised tw:hover:-translate-y-px'
				>
					<span className='tw:w-[38px] tw:h-[38px] tw:shrink-0 tw:rounded-token tw:bg-accent tw:text-white tw:flex tw:items-center tw:justify-center tw:text-[18px]'>
						{action.icon}
					</span>
					<span className='tw:flex-1 tw:min-w-0'>
						<span className='tw:block tw:text-[13.5px] tw:font-semibold tw:text-ink-0 tw:tracking-[-0.005em]'>
							{action.label}
						</span>
						<span className='tw:block tw:text-[11.5px] tw:text-ink-3 tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis'>
							{action.sub}
						</span>
					</span>
					<FaChevronRight
						size={12}
						className='tw:shrink-0 tw:text-ink-4 tw:opacity-0 tw:transition-[opacity,transform] tw:duration-150 tw:group-hover:opacity-100 tw:group-hover:translate-x-0.5'
					/>
				</button>
			))}
		</div>
	);
}

export default QuickActionsRow;
